import { render, staticRenderFns } from "./ProjectActorDialogInfo.vue?vue&type=template&id=5f63db25&scoped=true&"
import script from "./ProjectActorDialogInfo.vue?vue&type=script&lang=js&"
export * from "./ProjectActorDialogInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProjectActorDialogInfo.vue?vue&type=style&index=0&id=5f63db25&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f63db25",
  null
  
)

export default component.exports